import { Tappable } from "@trueskin-web/components"

const ToggleButton = ({ isActive, children, onClick }) => (
  <Tappable
    onClick={onClick}
    sx={{
      flex: "auto",
      py: 2,
      justifyContent: "center",
      lineHeight: "body",
      fontWeight: isActive ? "bold" : "normal",
      color: isActive ? "text" : "textLight",
      pointerEvents: isActive ? "none" : "auto",
      borderBottom: "2px solid",
      borderColor: isActive ? "black" : "neutralsMediumGrey",
      borderRadius: 0,
    }}
  >
    {children}
  </Tappable>
)

const TogglePlans = ({ activeFilter, onClick, isDiscounted }) => {
  const filters = [
    {
      key: 2,
      title: (
        <span sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          Auto-Refill
          {isDiscounted ? (
            <>
              {" "}
              <span
                sx={{
                  py: 1,
                  px: 2,
                  fontSize: 0,
                  fontWeight: "bold",
                  lineHeight: 1.4,
                  color: "text",
                  borderRadius: "4px",
                  background: "notification",
                }}
              >
                Spare 15 %
              </span>
            </>
          ) : null}
        </span>
      ),
    },
    {
      key: 1,
      title: "Einmalkauf",
    },
  ]

  return (
    <div
      data-component-name="PlanSelectionSwitcher"
      sx={{
        display: "flex",
        alignItems: "center",
        my: 2,
        p: 1,
        borderRadius: "8px",
      }}
    >
      {filters.map((filter) => (
        <ToggleButton
          key={filter.key}
          isActive={activeFilter === filter.key}
          onClick={() => onClick(filter.key)}
        >
          {filter.title}
        </ToggleButton>
      ))}
    </div>
  )
}

export default TogglePlans
